import { UsersService } from "@/services/api-service";

const state = {
  count: 0,
  pages: 1,
  list: [],
  current: {},
  original: {},
  originalJSON: ""
};

const getters = {
  count: state => state.count,
  pages: state => state.pages,
  list: state => state.list,
  current: state => state.current,
  isDirty: state => {
    const currentJSON = JSON.stringify(state.current);
    return currentJSON !== state.originalJSON;
  }
};

const actions = {
  async fetchList(context, params) {
    if (params.offset === 0) context.commit("reset");
    const { data } = await UsersService.query(params);
    context.commit("set", {
      result: data,
      limit: params.limit
    });
  },

  async fetch(context, id) {
    const { data } = await UsersService.get(id);
    context.commit("setCurrent", data.user);
  },
  async add(context, user) {
    await UsersService.add(user);
    await context.dispatch("fetchList", { limit: 20, offset: 0 });
  },
  async save(context) {
    await UsersService.save(state.current);
    context.commit("setCurrent", state.current);
  },
  async delete(context) {
    await UsersService.destroy(state.current.subject);
    context.commit("remove", state.current);
  },
  async addRoles(context, roles) {
    await UsersService.addRoles(state.current.subject, roles);
    await context.dispatch("fetch", state.current.subject);
  },
  async removeRoles(context, roles) {
    await UsersService.removeRoles(state.current.subject, roles);
    await context.dispatch("fetch", state.current.subject);
  },
  async addClaim(context, claim) {
    await UsersService.addClaim(state.current.subject, claim);
    await context.dispatch("fetch", state.current.subject);
  },
  async removeClaim(context, claim) {
    await UsersService.removeClaim(state.current.subject, claim);
    await context.dispatch("fetch", state.current.subject);
  }
};

const mutations = {
  set(state, data) {
    state.list.push(...data.result.users);
    state.count = data.result.usersCount;
    state.pages =
      Math.ceil(state.count / data.limit) == 0
        ? 1
        : Math.ceil(state.count / data.limit);
  },
  reset(state) {
    state.list = [];
    state.count = 0;
    state.pages = 1;
  },
  setCurrent(state, entity) {
    state.original = entity;
    state.current = entity;
    state.originalJSON = JSON.stringify(state.original);
  },
  remove(state, entity) {
    state.list.splice(state.list.indexOf(entity), 1);
    state.current = {};
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
